import React from 'react'
import TurnOffIcon from '@material-ui/icons/PowerSettingsNew';
import Tr from 'translations/Translations';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconTurnOffButton(
    {
        tooltip = Tr('stop'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={TurnOffIcon}
        {...props}
    />
}

WorkableIconTurnOffButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconTurnOffButton;